import { Packer } from "docx"
import { saveAs } from "file-saver"

import { markdownToDocx } from "@/lib/file"

export async function downloadDocxFile(content: string, filename: string) {    
    const value = String(content)
    const doc = markdownToDocx(value)
    const blob = await Packer.toBlob(doc)
    saveAs(blob, `${filename}.docx`)
}